import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import isEmpty from "../validations/is-empty";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);

const getDate = (date) => {
  const timezone = isEmpty(localStorage.getItem("timezoneMode"))
    ? "Europe/London"
    : localStorage.getItem("timezoneMode");

  const d = dayjs(date).tz(timezone);

  const year = d.year();
  const month = String(d.month() + 1).padStart(2, "0");
  const day = String(d.date()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export default getDate;
